import { forwardRef } from 'react'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'



interface SwitchProps extends React.InputHTMLAttributes<HTMLInputElement> {
  classNameRoot?: string;
  classNameToggle?: string;
  classNameLabel?: string;
  switchSize?: 'extra_small' | 'small' | 'medium' | 'large';
}

const Switch = forwardRef<HTMLInputElement, SwitchProps>(
  (
    { classNameRoot, classNameToggle, classNameLabel, children, ...props },
    ref,
  ) => {
    const { switchSize = 'medium', ...restProps } = props

    return (
      <label className={cn(styles.switch, classNameRoot, styles[switchSize])}>
        <input
          type="checkbox"
          ref={ref}
          className={styles.input}
          {...restProps}
        />
        <span className={cn(styles.toggle, classNameToggle)} />
        {children && (
          <span className={cn(styles.label, classNameLabel)}>{children}</span>
        )}
      </label>
    )
  },
)

Switch.displayName = 'Switch'

export default Switch
